import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=bf807e5a&scoped=true"
import script from "./UpdatePassword.vue?vue&type=script&lang=js"
export * from "./UpdatePassword.vue?vue&type=script&lang=js"
import style0 from "./UpdatePassword.vue?vue&type=style&index=0&id=bf807e5a&prod&lang=scss&scoped=true"
import style1 from "./UpdatePassword.vue?vue&type=style&index=1&id=bf807e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf807e5a",
  null
  
)

export default component.exports